"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownValidation = exports.InputEmailValidation = exports.InputTextValidation = void 0;

var react_localization_1 = __importDefault(require("react-localization"));

var general_1 = require("../general");

var form_field_validation_1 = require("./form-field-validation");

var json = __importStar(require("./localization.json"));

var localizedStrings = new react_localization_1["default"](json);

if (typeof window !== 'undefined') {
  localizedStrings.setLanguage((0, general_1.getLanguage)());
}

var InputTextValidation = function InputTextValidation(value, minLength, maxLength) {
  if (!(0, form_field_validation_1.FormFieldValidation)(form_field_validation_1.FormFieldType.String, value, minLength, maxLength)) {
    if (!(0, form_field_validation_1.typeOfStringCheck)(value)) {
      return localizedStrings.formatString(localizedStrings.formValidation.incorrectFormFieldType, 'FormFieldType.String').toString();
    }

    if (value.length < minLength || value.length > maxLength) {
      return localizedStrings.formatString(localizedStrings.formValidation.incorrectLength, "" + minLength, "" + maxLength).toString();
    }
  }

  return null;
};

exports.InputTextValidation = InputTextValidation;

var InputEmailValidation = function InputEmailValidation(value) {
  if (!value) {
    return localizedStrings.formatString(localizedStrings.formValidation.formFieldEmpty, 'FormFieldType.Email').toString();
  }

  if (!(0, form_field_validation_1.FormFieldValidation)(form_field_validation_1.FormFieldType.Email, value)) {
    return localizedStrings.formatString(localizedStrings.formValidation.incorrectEmailField, value).toString();
  }

  return null;
};

exports.InputEmailValidation = InputEmailValidation;

var DropdownValidation = function DropdownValidation(value) {
  if (!value) {
    return localizedStrings.formatString(localizedStrings.formValidation.formFieldEmpty, 'FormFieldType.Dropdown').toString();
  }

  if (!(0, form_field_validation_1.FormFieldValidation)(form_field_validation_1.FormFieldType.Dropdown, value)) {
    return localizedStrings.formatString(localizedStrings.formValidation.incorrectFormFieldType, 'FormFieldType.Dropdown').toString();
  }

  return null;
};

exports.DropdownValidation = DropdownValidation;